import { Image, Space, Typography } from 'antd'
import dayjs from 'dayjs'
import { InstituteDefaultIcon } from '../assets/icons'


// Function to format Institute data
export const formatInstitute = (instituteData, token) => {
    const { Text } = Typography
    const { _id: valueInstitute, name: labelInstitute, logo: logoInstitute } = instituteData || {}
    return {
        label: labelInstitute && (
            <Space size={'large'}>
                {/* <div
                    style={{
                        width: '30px',
                        height: '30px',
                        padding: '8px 5px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: `1px solid ${token.colorPalette.textColor.quinary}`,
                    }}
                >
                    {logoInstitute ? (
                        <Image src={logoInstitute} height={'30px'} width={'30px'} preview={false} />
                    ) : (
                        <div style={{ width: '30px', height: '30px' }}>
                            <InstituteDefaultIcon />
                        </div>
                    )}
                </div> */}
                <Text>{labelInstitute}</Text>
            </Space>
        ),
        value: valueInstitute,
    }
}

// Function to handle date transformation
export const formatDate = (value) => {
    return dayjs(value).format('DD MMM YY')
}

// Function to format date picker
export const formatDatePicker = (value) => {
    return `${dayjs(value).format('DD MMM YY')}`
}


export const camelCaseToWordConverter = (key) => {
    return key
        ?.replace(/([a-z])([A-Z])/g, '$1 $2')
        ?.replace(/^./, (str) => str.toUpperCase())
}

export const buildQueryParams = (obj) => {
    const params = [];

    Object.entries(obj).forEach(([key, value]) => {
        if (key === 'experienceRange' && Array.isArray(value)) {
            if (value.length === 2) {
                const [from, to] = value;
                if (from !== undefined && from !== null) {
                    params.push(`totalExperienceFrom=${encodeURIComponent(from)}`);
                }
                if (to !== undefined && to !== null) {
                    params.push(`totalExperienceTo=${encodeURIComponent(to)}`);
                }
            }
        } else if (Array.isArray(value)) {
            value.forEach(val => {
                params.push(`${encodeURIComponent(key)}=${encodeURIComponent(val)}`);
            });
        } else if (value !== undefined && value !== null && value !== '') {
            params.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
        }
    });

    return params.join("&");
};


export const formatMilliseconds = (ms) => {
    if (ms < 1000) return `${ms} ms`

    const sec = ms / 1000
    if (sec < 60) return `${sec.toFixed(1)} sec`

    const min = sec / 60
    if (min < 60) return `${min.toFixed(1)} min`

    const hr = min / 60
    return `${hr.toFixed(1)} hr`
}